"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var sendTimeout = _ref.sendTimeout;
  return sendTimeout;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvc2VuZFRpbWVvdXQuanMiXSwibmFtZXMiOlsic2VuZFRpbWVvdXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7ZUFBZTtBQUFBLE1BQUdBLFdBQUgsUUFBR0EsV0FBSDtBQUFBLFNBQXFCQSxXQUFyQjtBQUFBLEMiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCAoeyBzZW5kVGltZW91dCB9KSA9PiBzZW5kVGltZW91dDtcbiJdfQ==